module.exports = __webpack_public_path__ + "img/sa.239857ca.svg";